import React, { useState, useEffect } from 'react';

import { Select, Spin } from 'antd';

import { withRouter } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import { searchWorkspaceMembers } from 'components/skills/skills_action';

const { Option } = Select;

function SelectMembers(props) {
  //   constructor(props) {
  //     super(props);
  //   }

  const dispatch = useDispatch();
  const [members, setData] = useState([]);
  //   const [value, setValue] = useState();
  const [loading, setloading] = useState(false);
  const [isSelecttion, setSelection] = useState(false);
  const currentUser = useSelector((state) => state.common_reducer.user);
  const handleSearch = (newValue) => {
    getData(newValue);
  };

  useEffect(() => {
    let isMounted = true;

    if (isSelecttion) {
      setSelection(false);
    } else {
      if (props.defaultUsers) {
        if (props.mode === 'multiple') {
          let data = members.concat(props.defaultUsers);
          //   let user=
          // )
          setData(data);
        } else {
          let data = members.push(props.defaultUsers);
          setData(data);
        }
      }

      // await dispatch(
      //   searchWorkspaceMembers(props.match.params.wId, '', props.type)
      // )
    }

    return () => {
      isMounted = false;
    };
  }, [props.defaultUsers]);
  //   const handleChange = (newValue: string) => {
  //     setValue(newValue);
  //   };
  const getData = async (newValue) => {
    setloading(true);
    // let res = await dispatch(
    //     updateSkill(cSkill._id, props.match.params.wId, { globalDefaults })
    //   );
    let data = await dispatch(
      searchWorkspaceMembers(props.match.params.wId, newValue, props.type)
    );
    setloading(false);
    if (data.data && data.data.members) {
      setData(data.data.members);
    }
  };

  const onDropdownVisibleChange = async (val) => {
    if (val) {
      setData([]);
      setloading(true);

      dispatch(
        searchWorkspaceMembers(props.match.params.wId, '', props.type)
      ).then((data) => {
        setloading(false);
        if (data.data && data.data.members) {
          setData(data.data.members);
        }
      });
    }
  };

  const getOptions = () => {
    let checkNameObj = {};
    let options = [];
    let alreadyThere = {};
    members.forEach((mem) => {
      if (mem) {
        let name, id, user_slack_id, timezone;
        if (props.excludeCurrentUser && mem.user_id === currentUser._id) {
          return;
        }
        if (!mem) {
          return;
        }
        if (mem.user_id) {
          let slackInfo = mem.slackInfo ? mem.slackInfo : mem;
          name = slackInfo
            ? slackInfo.displayName || slackInfo.name || slackInfo.user_name
            : mem.email;
          id = mem.user_id && mem.user_id._id ? mem.user_id._id : mem.user_id;
          user_slack_id = slackInfo.user_slack_id;
          timezone = slackInfo.timezone;
        } else {
          name =
            mem.displayName ||
            mem.name ||
            (mem.source && mem.source.user_name) ||
            mem.email;
          id = mem._id;
          user_slack_id = mem.source ? mem.source.user_slack_id : '';
          timezone = mem.timezone;
        }
        if (checkNameObj[name]) {
          name += ` (${mem.email})`;
        }

        if (props.rejectedUsers) {
          let isRejected = props.rejectedUsers.find((mem) => {
            let mId = mem.user_id
              ? mem.user_id._id || mem.user_id
              : mem._id || mem;
            return mId === id;
          });
          if (isRejected) {
            return;
          }
        }

        if (!alreadyThere[id]) {
          alreadyThere[id] = true;
          options.push(
            <Option
              key={id}
              value={id}
              user_slack_id={user_slack_id}
              _id={id}
              timezone={timezone}
              displayName={name}
            >
              {name}
            </Option>
          );
        }
      }
    });

    return options;
  };

  const onSelect = (val, event) => {
    setloading(true);
    setSelection(true);
    if (props.onSelect) {
      props.onSelect(val, event);
      dispatch(
        searchWorkspaceMembers(props.match.params.wId, '', props.type)
      ).then((data) => {
        setloading(false);
        if (data.data && data.data.members) {
          setData(data.data.members);
        }
      });
    }
  };

  const onChange = (val, event) => {
    setSelection(true);
    setloading(true);
    if (props.onChange) {
      props.onChange(val, event);
      dispatch(
        searchWorkspaceMembers(props.match.params.wId, '', props.type)
      ).then((data) => {
        setloading(false);
        if (data.data && data.data.members) {
          setData(data.data.members);
        }
      });
    }
  };

  //  console.log(props.value)
  return (
    <Select
      showSearch={true}
      allowClear={props.allowClear}
      title={props.title}
      style={props.style}
      mode={props.mode}
      showArrow={props.showArrow}
      className={props.className || ''}
      onDropdownVisibleChange={onDropdownVisibleChange}
      placeholder={
        props.placeholder
          ? props.placeholder
          : 'Start typing user Display Name ,Email, Name or Slack User Name'
      }
      onChange={onChange}
      onSelect={onSelect}
      onDeselect={props.onDeselect}
      value={props.value ? props.value : undefined}
      disabled={props.disabled}
      notFoundContent={loading ? <Spin size='small' /> : 'No User found'}
      onSearch={handleSearch}
      filterOption={(input, option) => option}
    >
      {getOptions()}
    </Select>
  );
}
export default withRouter(SelectMembers);
